import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { EntitlementProvider } from "@/context/EntitlementContext";
import { I18nProvider } from "@/context/I18nContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CompanyProfile from "@/pages/CompanyProfile";
import CompanyConfig from "@/pages/CompanyConfig";
import Users from "@/pages/Users";
import Roles from "@/pages/Roles";
import Approvals from "@/pages/Approvals";
import AuditLog from "@/pages/AuditLog";
import PlatformDashboard from "@/pages/PlatformDashboard";
import CustomerOrganizations from "@/pages/CustomerOrganizations";
import PricingPlans from "@/pages/PricingPlans";
import LanguageSettings from "@/pages/LanguageSettings";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Inquiries from "@/pages/Inquiries";
import InquiryDetail from "@/pages/InquiryDetail";
import Quotations from "@/pages/Quotations";
import QuotationDetail from "@/pages/QuotationDetail";
import ProformaInvoices from "@/pages/ProformaInvoices";
import ProformaInvoiceDetail from "@/pages/ProformaInvoiceDetail";
import Bookings from "@/pages/Bookings";
import Invoices from "@/pages/Invoices";
import Payments from "@/pages/Payments";
import Upgrade from "@/pages/Upgrade";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors closeButton theme={localStorage.getItem("tf-theme") !== "light" ? "dark" : "light"} />
      <I18nProvider>
        <BrowserRouter>
          <AuthProvider>
            <EntitlementProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/company/profile" element={<CompanyProfile />} />
                <Route path="/company/config" element={<CompanyConfig />} />
                <Route path="/company/users" element={<Users />} />
                <Route path="/company/roles" element={<Roles />} />
                <Route path="/approvals" element={<Approvals />} />
                <Route path="/audit" element={<AuditLog />} />
                <Route path="/platform" element={<PlatformDashboard />} />
                <Route path="/platform/customers" element={<CustomerOrganizations />} />
                <Route path="/platform/pricing" element={<PricingPlans />} />
                <Route path="/settings/language" element={<LanguageSettings />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/customers/:customerId" element={<CustomerDetail />} />
                <Route path="/inquiries" element={<Inquiries />} />
                <Route path="/inquiries/:inquiryId" element={<InquiryDetail />} />
                <Route path="/quotations" element={<Quotations />} />
                <Route path="/quotations/:quotationId" element={<QuotationDetail />} />
                <Route path="/finance/proforma-invoices" element={<ProformaInvoices />} />
                <Route path="/finance/proforma-invoices/:id" element={<ProformaInvoiceDetail />} />
                <Route path="/finance/payments" element={<Payments />} />
                <Route path="/finance/bookings" element={<Bookings />} />
                <Route path="/finance/invoices" element={<Invoices />} />
                <Route path="/upgrade" element={<Upgrade />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </EntitlementProvider>
          </AuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
